import React from 'react'
import '../style/sideNav.scss'

function SideNav(props) {
  const reserveGiftArr = [{ target: 5, gift1: '体力×300 ', gift2: '金币×888888' }, { target: 10, gift1: '法阵能量×2000', gift2: '材料兑换券×15' }, { target: 15, gift1: '七彩盾菇×15 ', gift2: '召唤卷轴×5' }, { target: 20, gift1: '水晶×30', gift2: '钻石×1000' }]
  const lineHeight = [20, 40, 202, 362, 522, 658];
  const level = Math.floor(props.totalCount / 50000) > 5 ? 5 : Math.floor(props.totalCount / 50000);
  const extraTotalLength = level === 0 ? 20 : (lineHeight[level + 1] - lineHeight[level]);
  const extraLength = extraTotalLength * ((props.totalCount % 50000) / 50000);
  const totalLength = level === 5 ? 658 : extraLength + lineHeight[level];

  return (
    <div className={`progress-side-bar ${props.isSideProgressShow ? '' : 'hide'} ${props.isProgressHidden ? 'hidden' : ''}`}>
      <div className="content">
        <div className="progress-container">
          <div className="progress-line-container">
            <div className="progress-line-active" style={{ height: totalLength + 'px' }}></div>
          </div>
          <ul className="reserve-gift">
            {
              reserveGiftArr.map(item => (
                <li key={item.target} className={item.target <= props.totalCount / 10000 ? 'active' : ''}>
                  <div className="point"><div className="inner"></div></div>
                  <h3>{item.target}万</h3>
                  <div className="item-container">
                    <div className="icon-container"><div className="icon"></div></div>
                    <div className="icon-container"><div className="icon"></div></div>
                  </div>
                  <p>{item.gift1}</p>
                  <p>{item.gift2}</p>
                </li>
              ))
            }
          </ul>
        </div>
        <div className={`reserve-btn ${props.phone ? 'reserved' : ''}`} onClick={props.toggleReservePop}></div>
        <p className="total">现已集结<span>{Math.floor(props.totalCount / 10000)}W</span>人</p>
      </div>
      <div className="toggle-btn" onClick={props.toggleSideBar}>
        <div className="arrow"></div>
        {props.isSideProgressShow && <span>关闭</span>}
        {!props.isSideProgressShow && <span>展开</span>}
      </div>
    </div>
  )
}

export default SideNav;
